export default "__VITE_ASSET__2046871d__"